class RefillPopups extends HTMLElement {
    constructor() {
        super();

        this.classes = {
            popupOpen: "refill-page__popup--open"
        };
        this.access = this.dataset.access === 'true';
        this.customer = this.dataset.customer;

        this.redBoxPopup = this.querySelector('#RefillRedBox');
        this.loginPopup = this.querySelector('#LoginRedBox');

        this.init()
    }

    init() {
        if (!(this.customer !== 'false')) {
            this.openPopup(this.loginPopup)
            return
        }

        if (!this.access) {
            this.openPopup(this.redBoxPopup)
        }
    }

    openPopup(popup) {
        popup.classList.add(this.classes.popupOpen);
        const popupContent = popup.querySelectorAll('.js-refill-popup-content');
        bodyScrollLock.disableBodyScroll(popupContent);
    }
}

customElements.define('refill-popups', RefillPopups);